/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import React from "react";
import { ArrowIcon } from "ui/ArrowIcon";

import type { FC } from "react";

export const BackButton: FC<{
  isDarkMode: boolean;
  handleBackButton: () => void;
}> = ({ isDarkMode, handleBackButton }) => {
  return (
    <div
      css={css`
        display: flex;
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: 4px;
          cursor: pointer;
        `}
        onClick={handleBackButton}
      >
        <ArrowIcon
          css={css`
            width: 16px;
            height: auto;
            fill: ${isDarkMode ? "#fff" : "#000"};
          `}
        />
        <div
          css={css`
            color: ${isDarkMode ? "#fff" : "#000"};
            font-size: 14px;
          `}
        >
          戻る
        </div>
      </div>
    </div>
  );
};
